import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';

import TabSingleTextWrapper from '../../../../common/tabSingleTextWrapper';

const PreClinicalInVivo = forwardRef(({ permissions: { disableEdit }, data }, ref) => {
  const {
    current: { phases, id: drugId, ingestedId },
    original: { phases: originalData },
    ingested: {
      phases: { data: ingestedData, fieldActions: ingestedActions },
    },
  } = useSelector(state => state.drugs, shallowEqual);
  return (
    <TabSingleTextWrapper
      disableEdit={disableEdit}
      footerData={data}
      data={phases}
      parentKey="phases"
      childKey="inVivo"
      drugId={drugId}
      ingestedId={ingestedId}
      originalData={originalData}
      ingestedData={ingestedData['inVivo']}
      ingestionAction={ingestedActions['inVivo']}
      parentIngestionAction={ingestedActions}
      ref={ref}
    />
  );
});

PreClinicalInVivo.propTypes = {
  permissions: PropTypes.object.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    isTab: PropTypes.bool.isRequired,
    tabs: PropTypes.array.isRequired,
  }),
};

PreClinicalInVivo.displayName = 'PreClinicalInVivo';

export default PreClinicalInVivo;
